import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useQueryKeySelector } from '@/packages/redux-state/store/slices/jsonQuery';

import { FetchSearchOffersDesktopLoadService } from '../load';

export const useFetchSearchOffersDesktopService = (): FetchSearchOffersDesktopLoadService => {
  const queryClient = useQueryClient();

  const queryKey = useQueryKeySelector();

  return useMemo(() => new FetchSearchOffersDesktopLoadService(queryClient, queryKey), [queryClient, queryKey]);
};
